export class ConfirmDialogConfig {
	headline: string = 'Eintrag löschen?';
	text: string = 'Sind Sie sich sicher, dass dieser Eintrag gelöscht werden soll?';
	confirmButtonText: string = 'Ja';
	cancelButtonText: string = 'Nein';
	confirmIcon?: string;
	cancelIcon?: string;
	saveButtonText?: string;
	saveIcon?: string;
	showFeedbackInline?: boolean;
	shouldOpen: boolean = true;
	hideCancelButton: boolean = false;
}
